<template>
  <template v-if="flatten">
    <li
      class="border-b border-brand"
      v-for="child in childrensList"
      :key="child.path"
      @click="handleClick"
    >
      <div class="flex-nowrap flex items-center cursor-pointer">
        <router-link
          class="hover-hover:hover:text-primary whitespace-nowrap block w-full p-4 text-lg font-bold text-center"
          :to="`${route.path}/${child.path}`"
          v-text="getLabel(child)"
        >
        </router-link>
      </div>
      <hr />
    </li>
  </template>
  <li
    class="border-b border-brand"
    v-else-if="show"
    @click="hasChildren ? (open = !open) : handleClick()"
  >
    <div class="flex-nowrap flex items-center cursor-pointer">
      <component
        :is="hasChildren ? 'span' : 'router-link'"
        class="hover-hover:hover:text-primary whitespace-nowrap block w-full p-4 text-lg font-bold text-center"
        :to="route.path"
        v-text="getLabel(route)"
      />
      <template v-if="hasChildren"
        ><div class="flex-1" />
        <app-caret :open="open" class="flex-none" />
      </template>
    </div>
    <transition name="accordion">
      <ul v-if="hasChildren && open">
        <li v-for="child in childrensList" :key="child" @click="handleClick">
          <router-link
            class="hover-hover:hover:text-primary whitespace-nowrap block p-4 text-center"
            :to="`${route.path}/${child.path}`"
            v-text="getLabel(child)"
          >
          </router-link>
        </li>
      </ul>
    </transition>
    <hr />
  </li>
</template>

<script>
import _ from "lodash";
export default {
  props: ["route"],
  emits: ["close"],
  data: () => ({ open: false }),
  computed: {
    show() {
      return !_.get(this.route.meta, "hideMenu.main");
    },
    flatten() {
      return this.route.meta.flatten;
    },
    hasChildren() {
      return (
        !_.isEmpty(this.route.children) &&
        this.route.redirect &&
        !this.route.meta.directLink
      );
    },
    childrensList() {
      return _.filter(
        this.route.children,
        i => !_.get(i.meta.hideAsChild, "main")
      );
    }
  },
  methods: {
    handleClick() {
      this.$emit("close");
    },
    getLabel(item) {
      return _.get(item, "meta.label") || item.name;
    }
  }
};
</script>
